import { DOMNode, Element } from "html-react-parser"

export default function isElement(domNode: DOMNode): domNode is Element {
  const isTag = domNode.type === `tag`
  const hasAttributes = (domNode as Element).attribs !== undefined

  return isTag && hasAttributes
}
